import { Box, Stack, Typography } from "@mui/material";
import React, { useState } from "react";
import { ContentLayout } from "../../layout/contentLayout";

import useResponsive from "../../hooks/useResponsive";

import { SearchAccount, SearchPost } from "./search-info";
import { MetaDataType } from "../../interface/search";

const paths = ["Post", "Account"];
const SearchContent = ({
  search_data,
  search,
  state,
  lga,
  resp,
  reps_name,
}: {
  search_data: { data: any[]; meta: MetaDataType };
  search: string;
  state: string;
  reps_name: string;
  lga: string;
  resp: string;
}) => {
  const [path_name, setPath_name] = useState("Post");
  const isSmall = useResponsive("down", "sm", "xl");
  const handle_path_name = (path_name: string) => setPath_name(path_name);

  return (
    <ContentLayout>
      <Box
        sx={{
          maxWidth: isSmall ? "98%" : 560,
          mx: "auto",
          py: "80px",
          px: isSmall ? 1 : 3,
        }}
      >
        <Typography variant="h6" sx={{ fontWeight: 600 }}>
          Search Results for {search}
        </Typography>
        <Typography variant="body2" sx={{ fontWeight: 600 }}>
          {state?.length > 1 ? ` In ${state} state` : ``}
        </Typography>
        <Typography variant="body2" sx={{ fontWeight: 600 }}>
          {lga?.length > 1 ? ` In ${lga} local government` : ``}
        </Typography>
        {/* <Typography variant="body2" sx={{ fontWeight: 600 }}>
          {reps_name?.length > 1 ? ` Representative: ${reps_name}` : ``}
        </Typography> */}

        <Box>
          <Stack
            direction={"row"}
            justifyContent={"space-around"}
            sx={{
              backgroundColor: "#E2F1EB00",
              borderTop: "1px solid #E7EBEF",
              boxShadow: `0px 2px 7px 0px #45917326`,
              borderRadius: "8px",
              my: 2,
              p: 2,
              overflowX: "auto",
            }}
          >
            <Stack
              sx={{
                mx: 1,
                px: 1,
                cursor: "pointer",
              }}
            >
              <Typography
                sx={{
                  fontWeight: 500,
                  color: "#637D92",
                  whiteSpace: "nowrap",
                }}
              >
                Search Result
              </Typography>
            </Stack>
          </Stack>
          {resp === "false" ? (
            <SearchPost data={search_data?.data} />
          ) : (
            <SearchAccount data={search_data?.data} />
          )}
        </Box>
      </Box>
    </ContentLayout>
  );
};

export default SearchContent;
